export class Price {
    constructor(public amount: number, public currency: string = 'NZD') {
    }
}
